import { createServiceToken } from '@/app/di';
import type { IPatientRepository } from './domain/repositories/patient.repository';

export const PATIENTS_SERVICE = createServiceToken<IPatientRepository>('PatientsService');
